// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__GIEsD","star":"Rating_star__MYEzm","first_star":"Rating_first_star__fxRNe","halfStar":"Rating_halfStar__zqXOt"};